var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOfficechairSvgBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Office chair_SVG_Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.21,318.89V301.34a84,84,0,0,0-37.64-70V94.5A41.67,41.67,0,0,0,310,52.88h-120A41.66,41.66,0,0,0,148.29,94.5V231.35a84,84,0,0,0-37.64,70v17.55H237.49v54.58H214.75a58,58,0,0,0-58,58v3.25h24.88v-3.25a33.13,33.13,0,0,1,33.09-33.09h22.74v36.34h24.88V398.34h22.74a33.14,33.14,0,0,1,33.09,33.09h24.88a58,58,0,0,0-58-58H262.37V318.89ZM173.16,94.5A16.76,16.76,0,0,1,189.9,77.75H310A16.76,16.76,0,0,1,326.7,94.5V220.15a83.67,83.67,0,0,0-21.48-2.8H194.65a83.69,83.69,0,0,0-21.49,2.8Zm21.49,147.73H305.22A59.2,59.2,0,0,1,363.88,294H136A59.2,59.2,0,0,1,194.65,242.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOfficechairSvgBlack);
export default __webpack_public_path__ + "static/media/Icon_Office chair_SVG_Black.6a9f0157546b389655a6adc58e8c1974.svg";
export { ForwardRef as ReactComponent };